import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Product from '../components/Product';
import SEO from '../components/SEO';

const ProductPage = () => {
  return (
    <>
      <SEO 
        title="Kidsphere | Flagship EdTech by CodeRidge — Built Like Enterprise Software"
        description="Kidsphere: life-skills learning for children—secure, scalable, and analytics-ready. CodeRidge's flagship product, engineered with the same discipline as our cloud, security, and automation engagements."
        keywords="Kidsphere, EdTech, life skills learning, COPPA, children's education app, CodeRidge product, secure learning platform"
        url="https://coderidge.in/product"
      />
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <Product />
      </div>
      <Footer />
    </>
  );
};

export default ProductPage;










